<!-- 单选框 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1">内容设置</MenuItem>
                <MenuItem name="2">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <div v-if="name_id == 1">
                    <Form
                        :model="newFormData"
                        label-position="left"
                        :label-width="80"
                    >
                        <div class="form-title">预设类型</div>
                        <FormItem label="字段属性">
                            <RadioGroup
                                v-model="newFormData.content.field_attribute"
                            >
                                <Radio class="mr24" label="1">必填</Radio>
                                <Radio class="mr24" label="2">不必填</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="记录结果">
                            <RadioGroup
                                v-model="newFormData.content.record_result"
                            >
                                <Radio class="mr24" label="1"
                                    >作为记录结果</Radio
                                >
                                <Radio class="mr24" label="2"
                                    >不作为记录结果</Radio
                                >
                            </RadioGroup>
                        </FormItem>
                        <div class="form-title">标题设置</div>
                        <FormItem label="内容标题">
                            <Input
                                v-model="newFormData.content.title"
                                placeholder="请输入内容标题"
                            ></Input>
                        </FormItem>
                        <FormItem label="标题颜色">
                            <ColorPicker
                                v-model="newFormData.content.title_color"
                            />
                        </FormItem>
                        <div class="form-title">选择样式</div>
                        <FormItem label="选择样式">
                            <RadioGroup
                                v-model="newFormData.content.select_style_value"
                            >
                                <Radio class="mr24" label="1">默认模式</Radio>
                                <Radio class="mr24" label="2">图文模式</Radio>
                            </RadioGroup>
                            <div
                                v-if="
                                    newFormData.content.select_style_value ==
                                    '1'
                                "
                                class="flex-sb mt8"
                            >
                                <div
                                    :class="
                                        newFormData.content.select_style == 1
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(1)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            1
                                        "
                                        src="@/assets/controlPanel/selectStyle/style4-active.png"
                                    />
                                    <img v-else src="@/assets/controlPanel/selectStyle/style4.png" />
                                    <span>样式一</span>
                                </div>
                                <div
                                    :class="
                                        newFormData.content.select_style == 2
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(2)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            2
                                        "
                                        src="@/assets/controlPanel/selectStyle/style6-active.png"
                                    />
                                    <img v-else src="@/assets/controlPanel/selectStyle/style6.png" />
                                    <span>样式二</span>
                                </div>
                                <div
                                    :class="
                                        newFormData.content.select_style == 3
                                            ? 'nav-active'
                                            : 'nav'
                                    "
                                    @click="changeNav(3)"
                                >
                                    <img
                                        v-if="
                                            newFormData.content.select_style ==
                                            3
                                        "
                                        src="@/assets/controlPanel/selectStyle/style7-active.png"
                                    />
                                    <img v-else src="@/assets/controlPanel/selectStyle/style7.png" />
                                    <span>样式三</span>
                                </div>
                            </div>
                        </FormItem>
                        <div class="form-title">添加选项</div>
                        <div
                            v-if="newFormData.content.select_style_value == '1'"
                            class="table-divs"
                        >
                            <div
                                class="table-div"
                                v-for="(e, index) of newFormData.content
                                    .table_list"
                                :key="index"
                            >
                                <div class="del-btn" @click="delIcon(index)">
                                    <Icon type="ios-trash" color="#fff" />
                                </div>
                                <div class="name-div">
                                    <div class="name-txt">
                                        {{ "选项" + (index + 1) }}
                                    </div>
                                    <Input
                                        v-model="e.name"
                                        placeholder="请输入选项名称"
                                    ></Input>
                                </div>
                            </div>
                            <div class="add-status" @click="addIcon">
                                <Icon type="md-add" size="20" color="#FF761D" />
                                <span>添加</span>
                            </div>
                        </div>
                        <div v-else class="table-divs">
                            <div
                                class="table-div2"
                                v-for="(e, index) of newFormData.content
                                    .table_list"
                                :key="index"
                            >
                                <div class="del-btn" @click="delIcon(index)">
                                    <Icon type="ios-trash" color="#fff" />
                                </div>
                                <div
                                    v-if="
                                        newFormData.content
                                            .select_style_value == '2'
                                    "
                                    class="upload-div"
                                    @click="openModal(index)"
                                >
                                    <img
                                        v-if="e.picview"
                                        class="upload-img"
                                        :src="e.picview"
                                    />
                                    <Icon
                                        v-else
                                        type="md-add"
                                        size="50"
                                        color="#C0C4CC"
                                    />
                                </div>
                                <div class="table-div3">
                                    <div>
                                        {{ "选项" + (index + 1) }}
                                    </div>
                                    <Input
                                        v-model="e.name"
                                        placeholder="请输入选项名称"
                                    ></Input>
                                </div>
                            </div>
                            <div class="add-status" @click="addIcon">
                                <Icon type="md-add" size="20" color="#FF761D" />
                                <span>添加</span>
                            </div>
                        </div>
                        <FormItem label="未选颜色">
                            <ColorPicker
                                v-model="newFormData.content.not_selected_color"
                            />
                        </FormItem>
                        <FormItem label="已选颜色">
                            <ColorPicker
                                v-model="newFormData.content.selected_color"
                            />
                        </FormItem>
                        <FormItem label="文本颜色">
                            <ColorPicker
                                v-model="newFormData.content.text_color"
                            />
                        </FormItem>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openModal('bg_img')">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div v-if="name_id == 2">
                <Form
                    :model="newFormData"
                    label-position="right"
                    :label-width="80"
                >
                    <div class="form-title">外间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.outer_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.outer_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">内间距</div>
                    <FormItem label="上下间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.top"
                        ></Slider
                    ></FormItem>
                    <FormItem label="左右间距"
                        ><Slider
                            v-if="newFormData.content.inner_spacing"
                            class="w300"
                            show-input
                            v-model="newFormData.content.inner_spacing.left"
                        ></Slider
                    ></FormItem>
                    <div class="form-title">圆角设置</div>
                    <FormItem label="上圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting.top
                            "
                        ></Slider
                    ></FormItem>
                    <FormItem label="下圆角"
                        ><Slider
                            v-if="newFormData.content.rounded_corner_setting"
                            class="w300"
                            show-input
                            v-model="
                                newFormData.content.rounded_corner_setting
                                    .bottom
                            "
                        ></Slider
                    ></FormItem>
                </Form>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            srctype: "",
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {},
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.srctype == "bg_img") {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.bg_img.picview = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.bg_img.value = param2[i];
                }
            } else {
                for (var i = 0; i < param1.length; i++) {
                    this.newFormData.content.table_list[this.srctype].picview =
                        param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.newFormData.content.table_list[this.srctype].value =
                        param2[i];
                }
            }
            this.$Message.destroy();
        },
        openModal(index) {
            this.switch_modal = true;
            this.srctype = index;
        },
        selectName(name) {
            this.name_id = name;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        changeNav(i) {
            this.newFormData.content.select_style = i;
        },
        // 添加
        addIcon() {
            this.newFormData.content.table_list.push({
                name: "",
                picview: "",
                value: "",
            });
        },
        // 删除
        delIcon(i) {
            if (this.newFormData.content.table_list.length == 1) {
                this.$Message.info("至少保留一个");
            } else {
                this.newFormData.content.table_list.splice(i, 1);
            }
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #fff;
    border-color: #ff761d;
    color: #ff761d;
    box-shadow: -1px 0 0 0 #ff761d;
}
::v-deep .ivu-radio-group-button :hover {
    color: #ff761d;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.nav {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #484e66;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.nav-active {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ff761d;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #ff761d;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}
.mt8 {
    margin-top: 8px;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
.table-divs {
    margin-bottom: 12px;
    padding: 12px;
    width: 100%;
    border: 1px solid #c0c4cc;
    border-radius: 4px;
}
.table-div {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #c0c4cc;
    position: relative;
    border-radius: 4px;
}
.del-btn {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
    margin-left: 12px;
    width: 28px;
    height: 28px;
    background: #ff761d;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.add-status {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #ff761d;
    cursor: pointer;
    font-size: 15px;
}
.add-status span {
    margin-left: 4px;
}
.upload-div {
    margin-right: 12px;
    width: 70px;
    height: 70px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.upload-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.table-div2 {
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #c0c4cc;
    position: relative;
    border-radius: 4px;
    display: flex;
    align-items: center;
}
.table-div3 {
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.name-div {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.name-txt {
    min-width: 60px;
}
</style>